import { LockBodyScroll } from "../LockBodyScroll";
import { cn } from "cy-fe/src/utils/cn";
import { LoadingSpinner } from "./LoadingSpinner";

export function LoadingOverlay({
  "data-testid": dataTestId,
}: {
  "data-testid"?: string;
}) {
  const baseTestId = dataTestId || "loading-overlay";
  return (
    <>
      <LockBodyScroll />
      <dialog
        data-testid={baseTestId}
        open
        className={cn(
          "fixed inset-0 z-[100] flex h-full w-full items-center justify-center",
        )}
      >
        <LoadingSpinner />
      </dialog>
    </>
  );
}
